var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statusCell yx-color-pure-1"},[_c('el-switch',{attrs:{"active-value":"1","inactive-value":"0","inactive-color":"#E2E3E8"},on:{"change":_vm.change},model:{value:(_vm.row.isPull),callback:function ($$v) {_vm.$set(_vm.row, "isPull", $$v)},expression:"row.isPull"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }